if (!customElements.get('shoppable-buy-all')) {
  customElements.define(
    'shoppable-buy-all',
    class ShoppableBuyAll extends HTMLElement {
      connectedCallback() {
        this._productRows = Array.from(
          this.querySelectorAll('[data-product-row]')
        );

        this._dots = Array.from(
          this.querySelectorAll(
            '.wt-shoppable-buy-all__dot'
          )
        );

        this._button = this.querySelector(
          '[data-buy-all-button]'
        );

        this._totalPriceEl = this.querySelector(
          '[data-total-price]'
        );

        this._errorEl = this.querySelector(
          '[data-error-message]'
        );

        this._cart = document.querySelector(
          'cart-drawer'
        );

        this._cartType =
          this._cart?.dataset.cartType || 'page';

        this._productRows.forEach(row =>
          this._initRow(row)
        );

        this._dots.forEach(dot =>
          this._initDot(dot)
        );

        this._updateTotal();
        this._updateButtonState();

        this._onButtonClick = event => {
          event.preventDefault();

          if (
            this._button?.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {
            this._showError(
              'Please choose a size for each pajama.'
            );
            return;
          }

          this._handleBuyAll();
        };

        this._onButtonKeydown = event => {
          if (
            event.key !== ' ' &&
            event.key !== 'Enter'
          ) {
            return;
          }

          event.preventDefault();

          if (
            this._button?.getAttribute(
              'aria-disabled'
            ) === 'true'
          ) {
            this._showError(
              'Please choose a size for each pajama.'
            );
            return;
          }

          this._handleBuyAll();
        };

        this._button?.addEventListener(
          'click',
          this._onButtonClick
        );

        this._button?.addEventListener(
          'keydown',
          this._onButtonKeydown
        );
      }

      disconnectedCallback() {
        this._button?.removeEventListener(
          'click',
          this._onButtonClick
        );

        this._button?.removeEventListener(
          'keydown',
          this._onButtonKeydown
        );

        this._productRows?.forEach(row => {
          row._variantSelect?.removeEventListener(
            'change',
            row._variantSelectFn
          );

          row._titleRow?.removeEventListener(
            'click',
            row._quickViewFn
          );

          row._thumb?.removeEventListener(
            'click',
            row._quickViewFn
          );
        });

        this._dots?.forEach(dot => {
          dot.removeEventListener(
            'mouseenter',
            dot._enterFn
          );

          dot.removeEventListener(
            'mouseleave',
            dot._leaveFn
          );
        });
      }

      _initDot(dot) {
        dot._enterFn = () =>
          this._activateRow(dot.dataset.blockId);

        dot._leaveFn = () =>
          this._deactivateRows();

        dot.addEventListener(
          'mouseenter',
          dot._enterFn
        );

        dot.addEventListener(
          'mouseleave',
          dot._leaveFn
        );
      }

      _activateRow(blockId) {
        this._productRows.forEach(row => {
          if (row.dataset.blockId === blockId) {
            row.classList.add(
              'wt-shoppable-buy-all__product-row--active'
            );

            row.classList.remove(
              'wt-shoppable-buy-all__product-row--dim'
            );
          } else {
            row.classList.add(
              'wt-shoppable-buy-all__product-row--dim'
            );

            row.classList.remove(
              'wt-shoppable-buy-all__product-row--active'
            );
          }
        });
      }

      _deactivateRows() {
        this._productRows.forEach(row => {
          row.classList.remove(
            'wt-shoppable-buy-all__product-row--active',
            'wt-shoppable-buy-all__product-row--dim'
          );
        });
      }

      _initRow(row) {
        const select = row.querySelector(
          '[data-variant-select]'
        );

        if (select) {
          row._variantSelect = select;

          const existingPlaceholder =
            select.querySelector(
              'option[value=""]'
            );

          if (!existingPlaceholder) {
            const placeholder =
              document.createElement('option');

            placeholder.value = '';
            placeholder.textContent =
              'Choose a size';

            placeholder.disabled = true;
            placeholder.selected = true;

            select.insertBefore(
              placeholder,
              select.firstChild
            );
          }

          select.value = '';

          delete row.dataset.selectedVariantId;

          row._variantSelectFn = () => {
            this._clearError();
            this._updateVariant(row);
            this._updateTotal();
            this._updateButtonState();
          };

          select.addEventListener(
            'change',
            row._variantSelectFn
          );
        }

        const titleRow = row.querySelector(
          '[data-title-row]'
        );

        const thumb = row.querySelector(
          '.wt-shoppable-buy-all__product-thumb'
        );

        const quickAddBtn = row.querySelector(
          '.wt-shoppable-buy-all__quick-add button'
        );

        if (
          quickAddBtn &&
          (titleRow || thumb)
        ) {
          row._quickViewFn = event => {
            if (
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey
            ) {
              return;
            }

            event.preventDefault();
            quickAddBtn.click();
          };

          if (titleRow) {
            row._titleRow = titleRow;

            titleRow.addEventListener(
              'click',
              row._quickViewFn
            );
          }

          if (thumb) {
            row._thumb = thumb;

            thumb.addEventListener(
              'click',
              row._quickViewFn
            );
          }
        }
      }

      _updateVariant(row) {
        const select = row._variantSelect;

        if (!select) return;

        const option =
          select.options[select.selectedIndex];

        if (!option || !option.value) {
          delete row.dataset.selectedVariantId;
          return;
        }

        row.dataset.selectedVariantId =
          option.value;

        if (option.dataset.priceCents) {
          row.dataset.priceCents =
            option.dataset.priceCents;
        }

        const priceEl = row.querySelector(
          '[data-price]'
        );

        if (
          priceEl &&
          option.dataset.variantPrice
        ) {
          priceEl.textContent =
            option.dataset.variantPrice;
        }

        this._updateComparePrice(
          row,
          option
        );
      }

      _updateComparePrice(row, option) {
        const wrapper = row.querySelector(
          '[data-price-wrapper]'
        );

        const compareEl = row.querySelector(
          '[data-price-compare]'
        );

        if (!wrapper || !compareEl) return;

        const priceCents =
          parseInt(
            option.dataset.priceCents
          ) || 0;

        const compareCents =
          parseInt(
            option.dataset.compareCents
          ) || 0;

        const onSale =
          compareCents > priceCents;

        wrapper.classList.toggle(
          'wt-shoppable-buy-all__product-price--on-sale',
          onSale
        );

        compareEl.hidden = !onSale;

        if (
          onSale &&
          option.dataset.variantComparePrice
        ) {
          compareEl.textContent =
            option.dataset.variantComparePrice;
        }
      }

      _allSizesSelected() {
        return this._productRows.every(row => {
          if (!row._variantSelect) {
            return Boolean(
              row.dataset.selectedVariantId
            );
          }

          return Boolean(
            row._variantSelect.value &&
            row.dataset.selectedVariantId
          );
        });
      }

      _updateButtonState() {
        if (!this._button) return;

        const complete =
          this._allSizesSelected();

        this._button.classList.toggle(
          'wt-shoppable-buy-all__button--disabled',
          !complete
        );

        this._button.setAttribute(
          'aria-disabled',
          complete ? 'false' : 'true'
        );

        if (
          this._button.tagName === 'BUTTON'
        ) {
          this._button.disabled = !complete;
        }
      }

      _updateTotal() {
        if (!this._totalPriceEl) return;

        if (!this._allSizesSelected()) {
          this._totalPriceEl.textContent = '';
          return;
        }

        const totalCents =
          this._productRows.reduce(
            (sum, row) =>
              sum +
              (
                parseInt(
                  row.dataset.priceCents
                ) || 0
              ),
            0
          );

        this._totalPriceEl.textContent =
          this._formatMoney(totalCents);
      }

      _formatMoney(cents) {
        const currency =
          window.Shopify?.currency?.active ||
          'USD';

        try {
          return new Intl.NumberFormat(
            undefined,
            {
              style: 'currency',
              currency
            }
          ).format(cents / 100);
        } catch {
          return `${(
            cents / 100
          ).toFixed(2)} ${currency}`;
        }
      }

      async _handleBuyAll() {
        if (this._loading) return;

        if (!this._allSizesSelected()) {
          this._showError(
            'Please choose a size for each pajama.'
          );

          this._updateButtonState();
          return;
        }

        const items =
          this._productRows
            .map(row => ({
              id: Number(
                row.dataset.selectedVariantId
              ),
              quantity: 1
            }))
            .filter(item => item.id);

        if (
          items.length !==
          this._productRows.length
        ) {
          this._showError(
            'Please choose a size for each pajama.'
          );
          return;
        }

        this._loading = true;
        this._clearError();

        this._cart?.setActiveElement(
          document.activeElement
        );

        this._button.setAttribute(
          'aria-disabled',
          'true'
        );

        if (
          this._button.tagName === 'BUTTON'
        ) {
          this._button.disabled = true;
        }

        this._button.classList.add(
          'loading'
        );

        const spinner =
          this._button.querySelector(
            '.loading-overlay__spinner'
          );

        spinner?.classList.remove(
          'hidden'
        );

        try {
          const body = { items };

          if (
            this._cart &&
            typeof this._cart
              .getSectionsToRender ===
              'function'
          ) {
            body.sections =
              this._cart
                .getSectionsToRender()
                .map(section => section.id);

            body.sections_url =
              window.location.pathname;
          }

          const response = await fetch(
            window.routes.cart_add_url,
            {
              method: 'POST',
              headers: {
                'Content-Type':
                  'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify(body)
            }
          );

          const data =
            await response.json();

          if (!response.ok) {
            this._showError(
              data.description ||
              data.message ||
              response.statusText
            );
            return;
          }

          publish(
            PUB_SUB_EVENTS.cartUpdate,
            {
              source:
                'shoppable-buy-all',
              cartData: data
            }
          );

          this._openCartOrRedirect(data);
        } catch (error) {
          this._showError(
            error.message ||
            'Something went wrong. Please try again.'
          );
        } finally {
          this._loading = false;

          this._button.classList.remove(
            'loading'
          );

          spinner?.classList.add(
            'hidden'
          );

          this._updateButtonState();
        }
      }

      _openCartOrRedirect(data) {
        if (
          !this._cart ||
          this._cartType !== 'drawer'
        ) {
          window.location =
            window.routes.cart_url;
          return;
        }

        if (
          window.location.pathname ===
          window.routes.cart_url
        ) {
          window.location =
            window.routes.cart_url;
          return;
        }

        const isClosedCart =
          !document.body.classList.contains(
            'page-overlay-cart-on'
          );

        this._cart.renderContents(
          data,
          isClosedCart
        );
      }

      _showError(message) {
        if (!this._errorEl) return;

        this._errorEl.textContent =
          message;

        this._errorEl.removeAttribute(
          'hidden'
        );
      }

      _clearError() {
        if (!this._errorEl) return;

        this._errorEl.textContent = '';
        this._errorEl.setAttribute(
          'hidden',
          ''
        );
      }
    }
  );
}